<template>
    <!-- 签到有礼 -->
    <div class="sign_in">
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"></login-in>
        <div class="float-item">
            <!-- 活动规则 -->
            <div v-if="formCustom.checkinGuideSwitch === '1'"
                class="activity-rule"
                @click="isExplainShow = true">
                活动规则
            </div>
            <div v-if="formCustom.storeActivityCode"
                class="activity-rule"
                @click="toStoreNavigation">
                活动门店
            </div>
            <div class="activity-rule"
                @click="goMpRewardQuery">
                奖励查询
            </div>
        </div>
        <!-- 预约签到列表 -->
        <div id="top-half"
            class="top-half"
            :style="{ 'background-image': 'url(' + getPicUrl(formCustom.activityPictureUrl) + ')'}">
            <div class="appointment-check-in">
                <!-- 预约签到奖励列表 -->
                <div v-for="(item, index) in giftList"
                    :key="index"
                    class="sign-in-reward-list"
                    :class="giftList.length > 2 ? 'reward-list-len' : '' ">
                    <div class="gift-type">
                        {{ getTaskType() }}
                    </div>
                    <div class="reward-info">
                        <img :src="getPicUrl(item.goodsPictureUrl)">
                        <div class="gift-info">
                            <div class="gift-item-flex">
                                <div class="gift-title">
                                    {{ getRewardTitleInfo(item) }}
                                </div>
                                <div v-if="reservedStatus(item)"
                                    class="text-decoration"
                                    @click="toFormDetail(item)">已预约</div>
                            </div>
                            <div class="gift-item">
                                <div style="width: 60%;">
                                    <div class="gift-name ellipsis">
                                        {{ item.goodsType === GoodsType.accumulatePoints ? '积分奖励' : item.goodsName }}
                                    </div>
                                    <div class="gift-time">
                                        {{ getGiftTime(item) }}
                                    </div>
                                </div>
                                <div v-if="!(item.taskSubtype === TaskSubtype.onlineAppointment && item.rewardButtonStatus === SignInGiftRewardButtonStatus.noPrize)"
                                    class="button-item"
                                    :class="getButtonClass(item.rewardButtonStatus)"
                                    :style="getGiftRewardButtonStatus(item.rewardButtonStatus, item.rewardButtonText).length > 4 ? 'min-width:90px' : 'min-width:70px'"
                                    @click="goUse(item)">
                                    {{ getGiftRewardButtonStatus(item.rewardButtonStatus, item.rewardButtonText) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 签到成功弹窗  -->
        <div v-show="isSuccessShow"
            class="success-dialog">
            <div class="success">
                <img src="static/runtime/images/magic/signIn/check-mark-blue-big.png">
                <div class="success_content">
                    <div class="success_title">{{ taskSubtype === TaskSubtype.offlineSignIn ? '签到成功' : '预约成功' }}</div>
                    <div v-if="giftInfo && taskSubtype === TaskSubtype.offlineSignIn"
                        class="success_reward">
                        <span v-if="giftInfo.goodsName"
                            class="success_t">您已在“{{ giftInfo.channelName }}”签到成功，恭喜您获得以下奖品</span>
                        <span v-else
                            class="success_t">您已在“{{ giftInfo.channelName }}”签到成功</span>
                    </div>
                    <div v-if="giftInfo.goodsType !== GoodsType.noAward"
                        class="success-gift-list-parent">
                        <div class="success-gift-list">
                            <div class="gift-name">
                                {{ giftInfo.goodsType === GoodsType.accumulatePoints ? '积分+' + giftInfo.pointValue : giftInfo.exchangeGoodsName }}
                            </div>
                            <div class="to-use-button"
                                @click="toUse(giftInfo)">
                                去使用
                            </div>
                        </div>
                    </div>
                </div>
                <div class="closeDialog">
                    <van-icon name="cross"
                        @click="isSuccessShow = false" />
                </div>
            </div>
        </div>
        <!-- 签到失败 -->
        <signInFailedDialog :showDialog="signInFailed"
            img="static/runtime/images/magic/signIn/sign-in-failed.png"
            text="签到失败"
            @toStoreNavigation="toStoreNavigation"
            @closeDialog="signInFailed = false"></signInFailedDialog>
        <!-- 签到说明弹窗 -->
        <van-popup v-model="isExplainShow"
            closeOnClickOverlay
            class="van-dialog">
            <div class="explain">
                <div class="explain_title">活动规则</div>
                <div class="explain_content"
                    v-html="formCustom.checkinGuideInfo"></div>
                <div class="explain_closeDialog"
                    @click="isExplainShow = false">
                    <img src="../../../../static/runtime/images/magic/close-icon.png" />
                </div>
            </div>
        </van-popup>
        <!-- 实物权益品到店自提 -->
        <receiveAwardModal ref="receiveAwardModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :drawType="drawType"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal">
        </receiveAwardModal>
        <!-- 实物+线上邮寄 -->
        <realOnlineMailingModal ref="realOnlineMailingModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :userBase="userBase"
            :drawType="drawType"
            @handleRealOnlineMailing="getReceiveData(arguments)">
        </realOnlineMailingModal>
        <!-- 虚拟+线上兑换 -->
        <virtualOnlineAwardModal ref="virtualOnlineAwardModal"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :userBase="userBase"
            :isReceived="isReceived"
            @handleVirtualOnline="getReceiveData(arguments)"
            @nextStep="toNextStep"></virtualOnlineAwardModal>
        <!-- 实物+线下兑换、虚拟+线下核销发卡密、虚拟+线下核销 -->
        <codeCancelAfterVerfication v-if="codeShow"
            :awardObj="awardObj"
            :codeUrl="awardObj.writeOffCodeUrl"
            :writeOffCode="awardObj.writeOffCode"
            :extendConfigFlag="awardObj.extendConfigFlag"
            :activationCode="awardObj.activationCode"
            :effectiveStartTime="awardObj.effectiveStartTime"
            :effectiveEndTime="awardObj.effectiveEndTime"
            @closeEnd="closeEnd"
            @queryStatus="queryStatus"
            @refreshTaskList="refreshTaskList"
            @nextStep="toNextStep"></codeCancelAfterVerfication>
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>
</template>
<script>
import loginIn from './dynamicAttr/modal/login-in.vue';
import wx from 'weixin-js-sdk';
import { Dialog, Toast, Icon, Button, Calendar, Popup } from 'vant';
import receiveAwardModal from './dynamicAttr/modal/receiveAwardModal';
import virtualOnlineAwardModal from './dynamicAttr/modal/virtual-online';
import realOnlineMailingModal from '../../../components/modal/real-online-mailing-modal.vue';
import codeCancelAfterVerfication from '../../../components/modal/code-cancel-after-verification.vue';
import {
  JumpType,
  SignInStatus,
  SignInGiftRewardButtonStatus,
  GoodsType,
  AppointmentFlag,
  CollectionType,
  TaskSubtype,
  TaskType,
} from '../../../commons/commonVariables.js';
import signInFailedDialog from './sign-in-components/sign-in-failed-dialog.vue';
import { AMapGetLocation } from './TMap.js';
import { CoordinateType } from './lucky-draw/common/global-variable';
import { loadAlipayWebViewScript } from '../../../utils/comUtils.js';
import { BigWheelConstants as BWC } from './lucky-draw/common/global-variable';
import { noLoginHandler, checkClient, getPosition, jumpToNext, getValidity } from './common-methods/utils';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Calendar.name]: Calendar,
    [Popup.name]: Popup,
    loginIn,
    receiveAwardModal,
    virtualOnlineAwardModal,
    realOnlineMailingModal,
    codeCancelAfterVerfication,
    signInFailedDialog,
    IncorrectClient,
  },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      SignInGiftRewardButtonStatus: SignInGiftRewardButtonStatus, //活动状态
      TaskSubtype: TaskSubtype, //任务子类型:1:指定日期线下签到;2:指定日期线上预约
      TaskType: TaskType, //任务类型;1:指定日期线下签到;2:指定日期线上预约线下签到
      GoodsType: GoodsType, //奖项类型 0:无,1:虚拟,2:实物,3:平台优惠券,4:积分,5:微信代金券,6:赠品券,a1:柜机活动
      nextActivityCode: '', //自定义表单编码
      activityTypeFlag: '',
      isLoginFlag: false, // 默认没有登录
      activityCode: '',
      formCustom: {
        status: '', //活动状态
        checkinGuideSwitch: '', //是否开启签到攻略
        checkinGuideInfo: '', //签到攻略富文本
        activityPictureUrl: '', //签到背景
        storeActivityCode: '', //门店导航编码
      },
      clickFlag: false,
      awardObj: {
        extendReward: {},
      },
      drawCode: '', //多门店抽奖code
      channelCode: '', //门店编码
      isExplainShow: false, //活动规则弹窗显示控制
      isSuccessShow: false, // 签到成功弹窗显示控制
      loginType: '', // 活动登录类型
      miniprogramFlag: false, //判断是否在小程序打开
      userBase: {}, // 用户登录数据
      memberInfo: '', // 会员信息
      giftList: [],
      drawType: 'initDraw',
      signInFailed: false,
      checkRecordId: '',
      isReceived: false,
      userInfoList: [],
      codeShow: false,
      geolocation: {}, //new 对象
      positionInfo: {}, // 定位的地址
      giftInfo: {},
      setting: '',
      taskType: '', // 类型
      storeActivityCode: '', //门店导航编码
      formSettingId: '', //表单回带的settingId
      taskSubtype: '', //签到弹框
      adminRegions: {}, //行政区域ID对象
      originLoginType: BWC.LoginType.None,
      isCorrectClient: true,
    };
  },
  computed: {},
  async created() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    this.isCorrectClient = checkClient(this.originLoginType);
    // 从自定义表单跳回来
    this.setting = sessionStorage.getItem('setting');
    if (this.setting === 'true') {
      // 表单带回来的settingId
      const formSettingId = this.$route.query.settingId;
      // 跳转到登录界面之后，不让其回退。就直接添加下面这段代码即可实现
      history.pushState(null, null, document.URL);
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL);
      });
      // 从表单跳回的回调接口
      this.getGift(formSettingId);
    }

    let userInfo = sessionStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      this.userBase = userInfo;
    }
    this.adminRegions = JSON.parse(sessionStorage.getItem('adminRegions')) || {};
    this.loginType = sessionStorage.getItem('loginType');
    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '1';
    const code = this.$route.query.activityCode;
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
    this.activityCode = code;
    if (code && code.indexOf('_') > -1) {
      this.drawCode = code;
    }
    if (this.drawCode) {
      this.activityCode = this.drawCode.split('_')[0];
      this.channelCode = this.drawCode.split('_')[1];
    }
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
    // 判断是否在小程序内
    this.handleMiniprogramJudge();
    // 线上预约线下签到
    this.queryActivityCheckinGiftDetailH5();
    if (this.isLoginFlag) {
      this.positionInfo = await getPosition();
    }
  },
  mounted() {
    // 锁定微信 WebView 字体缩放，防止用户调大系统/微信字体后导致布局错乱
    const lockWxFontSize = () => {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
    };
    if (typeof WeixinJSBridge !== 'undefined') {
      lockWxFontSize();
    } else {
      document.addEventListener('WeixinJSBridgeReady', lockWxFontSize, false);
      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('WeixinJSBridgeReady', lockWxFontSize, false);
      });
    }
  },
  methods: {
    queryStatus(awardObj) {
      this.giftList.forEach((item) => {
        if (item.exchangeActivationCodeId === awardObj.id) {
          item.usedFlag = '4';
        }
      });
    },
    reservedStatus(item) {
      // 线上预约 && 已预约2 || 已领取无奖品11 || 去使用（不跳预约导购0 || 去使用（跳预约导购）1|| 已使用（已核销）3 || 已领取,权益品已过期10
      return (
        item.taskSubtype === TaskSubtype.onlineAppointment &&
        (item.rewardButtonStatus === SignInGiftRewardButtonStatus.rappointmentToUse ||
          item.rewardButtonStatus === SignInGiftRewardButtonStatus.noPrize ||
          item.rewardButtonStatus === SignInGiftRewardButtonStatus.noReservationReceived ||
          item.rewardButtonStatus === SignInGiftRewardButtonStatus.toUse ||
          item.rewardButtonStatus === SignInGiftRewardButtonStatus.writtenOff ||
          item.rewardButtonStatus === SignInGiftRewardButtonStatus.goodsExpired)
      );
    },
    getGift(settingId) {
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/selectUserCheckin`,
        params: {
          settingId: settingId,
        },
        success: async (r) => {
          if (r && r.result) {
            this.isSuccessShow = true;
            this.giftInfo = r.result;
            this.giftInfo.goodsType = r.result.exchangeGoodsType;
            this.giftInfo.goodsName = r.result.exchangeGoodsName;
            this.giftInfo.goodsId = r.result.exchangeGoodsId;
          }
        },
        failure: (err) => {
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
      sessionStorage.removeItem('setting');
    },
    getButtonClass(status) {
      let className = '';
      switch (status) {
        case SignInGiftRewardButtonStatus.writtenOff:
        case SignInGiftRewardButtonStatus.activityTerminated:
        case SignInGiftRewardButtonStatus.activityPaused:
        case SignInGiftRewardButtonStatus.taskNotStarted:
        case SignInGiftRewardButtonStatus.taskEnded:
        case SignInGiftRewardButtonStatus.goodsExpired:
        case SignInGiftRewardButtonStatus.noPrize:
          className = 'conditions-disabled';
          break;
        case SignInGiftRewardButtonStatus.signInWithoutAppointment:
          className = 'to-finish';
          break;
        case SignInGiftRewardButtonStatus.noReservationReceived:
        case SignInGiftRewardButtonStatus.toUse:
        case SignInGiftRewardButtonStatus.rappointmentToUse:
        case SignInGiftRewardButtonStatus.appointmentForm:
        case SignInGiftRewardButtonStatus.appointment:
          className = 'to-use';
          break;
        default:
          break;
      }

      if (!this.isLoginFlag) {
        className = 'conditions-disabled';
      }
      return className;
    },
    getTaskType() {
      let taskTypeText = '';
      if (this.taskType === TaskType.offlineSignIn) {
        taskTypeText = '线下签到';
      }
      if (this.taskType === TaskType.onlineAppointmentAndOfflineSignIn) {
        taskTypeText = '线上预约线下签到';
      }
      return taskTypeText;
    },
    /**
     *  任务类型;1:指定日期线下签到;2:指定日期线上预约线下签到
     *  任务子类型:1:指定日期线下签到;2:指定日期线上预约
     */
    getRewardTitleInfo(item) {
      let text = '';
      if (item.taskSubtype === TaskSubtype.offlineSignIn && (item.goodsName || item.goodsType === GoodsType.accumulatePoints)) {
        text = `线下签到奖励`;
      }
      if (item.taskSubtype === TaskSubtype.offlineSignIn && !item.goodsName && item.goodsType !== GoodsType.accumulatePoints) {
        text = `线下签到时间`;
      }
      if (item.taskSubtype === TaskSubtype.onlineAppointment && (item.goodsName || item.goodsType === GoodsType.accumulatePoints)) {
        text = `线上预约奖励`;
      }
      if (item.taskSubtype === TaskSubtype.onlineAppointment && !item.goodsName && item.goodsType !== GoodsType.accumulatePoints) {
        text = `线上预约时间`;
      }
      return text;
    },
    queryActivityCheckinGiftDetailH5() {
      const activityCode = this.activityCode;
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/queryActivityCheckinGiftDetailH5/${activityCode}`,
        params: null,
        success: async (r) => {
          if (r && r.result) {
            this.formCustom = r.result;
            this.formCustom.checkinGuideInfo = r.result.checkinGuideInfo ? r.result.checkinGuideInfo.replace(/ihlp/g, 'hd') : '';
            // 关联的表单活动
            this.nextActivityCode = r.result.nextActivityCode;
            this.giftList = r.result.activityRewardTaskList || [];
            this.taskType = r.result.taskType;
            // 绑定的门店导航编码
            this.storeActivityCode = r.result.storeActivityCode;
            if (r.result.activityStatus === SignInStatus.paused) {
              Dialog({ message: '活动已暂停' });
            } else if (r.result.activityStatus === SignInStatus.finished) {
              Dialog({ message: '活动已结束' });
            } else if (r.result.activityStatus === SignInStatus.notStarted) {
              Dialog({ message: '活动未开始' });
            }
          } else {
            Toast.clear();
            let content = '活动过于火爆，请稍后再试';
            if (r && r.message) {
              content = r.message;
            }
            self.clickFlag = false;
            Dialog({ message: content });
          }
        },
        failure: (err) => {
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 跳门店导航
    toStoreNavigation() {
      const path = `/hdmain?activityCode=${this.storeActivityCode}`;
      this.$router.push({
        path: path,
      });
    },
    // 活动时间
    getGiftTime(item) {
      const startDate = item.taskStartTime.split(' ')[0].replaceAll('-', '.');
      const endDate = item.taskEndTime.split(' ')[0].replaceAll('-', '.');
      if (startDate === endDate) {
        return `${startDate}`;
      } else {
        return `${startDate} - ${endDate}`;
      }
    },
    getGiftRewardButtonStatus(status, rewardButtonText) {
      /**
       * 0:已领取,不需要预约导购;------------------------去使用
       * 1:已领取,需要预约导购; -------------------------去使用
       * 2:已预约;---------------------------------------去使用（已预约导购）
       * 3:已核销; --------------------------------------已使用（已签到）
       * 4:用户未参与,活动终止; -------------------------活动已结束
       * 5:用户未参与,线下签到(签到); -------------------签到
       * 6:用户未参与,线上预约(线上预约); ---------------线上预约
       * 7:用户未参与,活动已暂停; -----------------------活动已暂停
       * 8:用户未参与,任务未开始; -----------------------活动未开始
       * 9:用户未参与,任务已结束; -----------------------活动已结束
       * 10:已领取,权益品已过期; ------------------------已过期
       * 11:已领取,无奖品; ------------------------------线上预约不展示，线下签到展示已签到
       * 12:用户未参与,线上预约(线上预约) 无绑定表单活动--线上预约
       */
      let type = '';
      switch (status) {
        case SignInGiftRewardButtonStatus.noReservationReceived:
        case SignInGiftRewardButtonStatus.toUse:
        case SignInGiftRewardButtonStatus.rappointmentToUse:
          type = '去使用';
          break;
        case SignInGiftRewardButtonStatus.writtenOff:
          type = '已使用';
          break;
        case SignInGiftRewardButtonStatus.activityTerminated:
        case SignInGiftRewardButtonStatus.taskEnded:
          type = '活动已结束';
          break;
        case SignInGiftRewardButtonStatus.signInWithoutAppointment:
        case SignInGiftRewardButtonStatus.appointmentForm:
        case SignInGiftRewardButtonStatus.appointment:
          type = rewardButtonText;
          break;
        case SignInGiftRewardButtonStatus.activityPaused:
          type = '活动已暂停';
          break;
        case SignInGiftRewardButtonStatus.taskNotStarted:
          type = '活动未开始';
          break;
        case SignInGiftRewardButtonStatus.goodsExpired:
          type = '已过期';
          break;
        case SignInGiftRewardButtonStatus.noPrize:
          type = '已签到';
          break;
        default:
          break;
      }
      return type;
    },
    // 提交用户信息
    getReceiveData(msg) {
      let param = {};
      if (msg.length === 0) {
        setTimeout(() => {
          this.toNextStep();
        }, 1000);
        this.$refs.realOnlineMailingModal.modalCancel();
        return;
      }
      if (msg.length === 3) {
        param = {
          recordId: this.checkRecordId,
          activityCode: this.activityCode,
          userInfo: {
            ...msg[2],
          },
        };
      } else if (msg.length === 4) {
        param = {
          recordId: this.checkRecordId,
          activityCode: this.activityCode,
          userInfo: {
            userName: msg[2],
            userPhone: msg[3],
          },
        };
      } else {
        param = {
          recordId: msg.checkinRecordId,
          activityCode: this.activityCode,
        };
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/submitActivityRecord`,
        params: param,
        success: (r) => {
          if (r.code === 200) {
            this.$refs.realOnlineMailingModal.modalCancel();
            Toast('领取成功');
            if (this.awardObj.goodsType === GoodsType.virtualAward && this.awardObj.collectionType === CollectionType.expressOrOnlineCheckOff) {
              // 虚拟线上兑换
              this.isReceived = true;
              this.awardObj.activationCode = r.result;
            } else if (this.awardObj.goodsType === GoodsType.entityAward && this.awardObj.collectionType === CollectionType.expressOrOnlineCheckOff) {
              // 实物线上邮寄
              setTimeout(() => {
                this.toNextStep();
              }, 1000);
            }
            this.queryActivityCheckinGiftDetailH5();
          } else {
            Toast(r.message);
          }
        },
      });
    },
    // 跳转小程序奖励查询页
    goMpRewardQuery() {
      jumpToNext('', JumpType.rewardInquiry, this.loginType, this);
    },
    // 查看表单填写详情
    toFormDetail(item) {
      if (!item.nextActivityCode) {
        return;
      }
      this.$router.push({
        name: 'submittedForm',
        query: { activityCode: item.nextActivityCode },
      });
    },
    // 奖品列表去使用
    async goUse(item) {
      const data = JSON.parse(JSON.stringify(item));
      this.userInfoList = data.userInfoList || [];
      this.awardObj = data;
      this.checkRecordId = data.rewardRecodeId;
      if (!this.isLoginFlag) {
        return;
      }
      // 去使用（不跳预约导购）
      if (data.rewardButtonStatus === SignInGiftRewardButtonStatus.noReservationReceived) {
        data.activitySettingId = data.id;
        this.toUse(data);
      }
      // 去使用（跳预约导购）
      if (data.rewardButtonStatus === SignInGiftRewardButtonStatus.toUse || data.rewardButtonStatus === SignInGiftRewardButtonStatus.rappointmentToUse) {
        const params = {
          goodsId: this.awardObj.goodsId || '', //(权益品id)",
          rewardRecodeId: this.checkRecordId || '', //(中奖记录表id)
          activityCode: this.awardObj.activityCode || '', //活动编码
        };
        const isNext = await getValidity(params, this.awardObj.rewardType);
        if (isNext) {
          this.toAppointmentGuide();
        }
      }
      // 线上预约有表单
      if (data.rewardButtonStatus === SignInGiftRewardButtonStatus.appointmentForm) {
        this.toNextActivityForm(data);
      }
      // 线下签到(签到) or 线上预约(线上预约) 无绑定表单活动
      if (
        data.rewardButtonStatus === SignInGiftRewardButtonStatus.signInWithoutAppointment ||
        data.rewardButtonStatus === SignInGiftRewardButtonStatus.appointment
      ) {
        this.toSignIn(data);
      }
    },
    // 无需预约核销码弹框
    writeOffFrame(settingId) {
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/writeOffFrame/${settingId}`,
        params: null,
        success: (r) => {
          if (r.code == 500) {
            Dialog({ message: r.message });
            this.clickFlag = false;
          } else {
            this.awardObj.writeOffCode = r.result.writeOffCode;
            this.awardObj.writeOffCodeUrl = r.result.writeOffCodeUrl;
            this.awardObj.activationCode = r.result.activationCode;
            this.codeShow = true;
            this.clickFlag = false;
          }
        },
        failure: (err) => {
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 线上预约有表单
    toNextActivityForm(data) {
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/nextActivity/${data.id}`,
        params: null,
        success: (r) => {
          if (r.code == 500) {
            Dialog({ message: r.message });
          } else {
            // 表单需要 奖项id settingId;奖品活动编码 giftActivityCode;
            const path = `/hdmain?activityCode=${data.nextActivityCode}&settingId=${data.id}&giftActivityCode=${this.activityCode}`;
            this.$router.push({
              path: path,
            });
          }
        },
      });
    },
    // 签到
    toSignIn(item) {
      // 正在签到
      if (this.clickFlag) {
        return false;
      }
      // 没有登录
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        // h5点击登陆后向小程序传参方便登陆成功后使用该标识再次跳转到当前h5页面
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.clickFlag = true;
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkinGift/doUserCheckin`,
        params: {
          settingId: item.id,
          dimension: this.positionInfo.latitude || '39.9042',
          longitude: this.positionInfo.longitude || '116.4074',
          userRewardRegion: this.adminRegions,
          coordinateType: this.positionInfo.coordinateType || CoordinateType.GCJ02,
        },
        success: (r) => {
          Toast.clear();
          if (r.code == 500) {
            Dialog({ message: r.message });
            this.clickFlag = false;
          } else {
            if (r.result.errorMsg) {
              this.signInFailed = true;
            } else {
              this.isSuccessShow = true;
            }
            this.giftInfo = r.result;
            this.giftInfo.goodsType = r.result.exchangeGoodsType;
            this.giftInfo.goodsName = r.result.exchangeGoodsName;
            this.giftInfo.goodsId = r.result.exchangeGoodsId;
            this.clickFlag = false;
            this.taskSubtype = item.taskSubtype;
            this.queryActivityCheckinGiftDetailH5();
          }
        },
        failure: (err) => {
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 奖品弹窗处理
    async toUse(item) {
      this.userInfoList = item.userInfoList || [];
      this.checkRecordId = item.rewardRecodeId;
      this.isSuccessShow = false;
      this.awardObj = item;
      this.awardObj.openSrc = '';
      this.awardObj.bigWheelActivityType = 1;
      this.activityObj.extendConfig = {
        awardPopupButtonColor: '',
      };
      let isNext = false;
      const params = {
        goodsId: this.awardObj.goodsId || '', //(权益品id)",
        rewardRecodeId: this.checkRecordId || '', //(中奖记录表id)
        activityCode: this.awardObj.activityCode || '', //活动编码
      };
      try {
        // 虚拟奖品-线上兑换
        if (this.awardObj.rewardType === GoodsType.virtualAward && this.awardObj.collectionType === CollectionType.expressOrOnlineCheckOff) {
          if (!item.activationCode) {
            // 用户未领取卡密
            isNext = await getValidity(params, this.awardObj.rewardType);
          }
        } else {
          // 其他权益品
          isNext = await getValidity(params, this.awardObj.rewardType);
        }
      } catch (err) {
        console.error(err);
      }
      // goodsType ,0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券
      // collectionType 领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟))
      //虚拟权益品
      if (item.goodsType === GoodsType.virtualAward) {
        setTimeout(async () => {
          if (
            item.appointmentFlag === AppointmentFlag.need &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode) &&
            isNext
          ) {
            this.toAppointmentGuide();
          } else {
            // 线上兑换
            if (item.collectionType === CollectionType.expressOrOnlineCheckOff && (isNext || item.activationCode)) {
              this.drawType = 'exchangegoods';
              if (item.activationCode) {
                this.isReceived = true;
              } else {
                this.isReceived = false;
              }
              this.$refs.virtualOnlineAwardModal.openModel();
            }
            // 线下核销
            if ((item.collectionType === CollectionType.checkOffStrCode || item.collectionType === CollectionType.inStore) && isNext) {
              item.drawOrderSource = null;
              this.writeOffFrame(item.activitySettingId);
            }
          }
        }, 100);
      }
      // 实物权益品
      else if (item.goodsType === GoodsType.entityAward) {
        if (item.appointmentFlag === AppointmentFlag.need && item.collectionType === CollectionType.inStore && isNext) {
          this.toAppointmentGuide();
        } else {
          if (item.collectionType === CollectionType.expressOrOnlineCheckOff && isNext) {
            this.drawType = 'exchangegoods';
            // 实物+线上邮寄
            if (item.extendConfig) {
              const userData = JSON.parse(item.extendConfig);
              item.extendConfigFlag = true;
              item.userAddressDetail = userData.userAddress.anonymizedText;
              item.userName = userData.userName.anonymizedText;
              item.userPhone = userData.userPhone.anonymizedText;
              item.userAddress = `${userData.userProvinceName}/${userData.userCityName}/${userData.userZoneName}`;
            }
            this.$nextTick(() => {
              this.$refs.realOnlineMailingModal.openModel();
            });
          }
          // 到店自提
          if (item.collectionType === CollectionType.inStore && isNext) {
            item.goodsName = item.rightsName;
            this.writeOffFrame(item.activitySettingId);
          }
        }
      }
      // 优惠券、代金券、积分
      else if (item.goodsType && [GoodsType.coupon, GoodsType.voucher, GoodsType.accumulatePoints].includes(item.goodsType)) {
        this.toNextStep();
      }
      // 赠品券
      else if (item.goodsType === GoodsType.giftCoupon) {
        setTimeout(() => {
          if (
            item.appointmentFlag === AppointmentFlag.need &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode)
          ) {
            if (isNext) {
              this.toAppointmentGuide();
            }
          } else {
            item.collectionType = CollectionType.inStore;
            item.drawOrderSource = null;
            this.writeOffFrame(item.activitySettingId);
          }
        }, 100);
      }
    },
    toNextStep() {
      // 积分跳转积分商城，需要携带活动编码
      if (this.awardObj.goodsType === GoodsType.accumulatePoints && this.awardObj.jumpUrl && this.awardObj.jumpUrl.trim() === BWC.jumpToPage.pointsMall) {
        jumpToNext(this.awardObj.jumpUrl, this.awardObj.jumpType, this.loginType, this, { activityCode: this.activityCode });
      } else {
        jumpToNext(this.awardObj.jumpUrl, this.awardObj.jumpType, this.loginType, this);
      }
    },

    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.kindAwardModal.openModel();
    },
    // 判断是否在小程序内
    handleMiniprogramJudge() {
      let that = this;
      if (this.loginType == 'wechat') {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      } else if (this.loginType == 'Alipay') {
        loadAlipayWebViewScript().then((res) => {
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(function (res) {
              if (res.miniprogram) {
                that.miniprogramFlag = res.miniprogram;
              }
            });
          }
        });
      }
    },
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    // 跳转预约导购
    async toAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.awardObj.exchangeActivationCodeId);
      this.path =
        result && result.guideId
          ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
          : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.exchangeActivationCodeId}&collectionType=${this.awardObj.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      let url = `/${this.path}`;
      const userBase = sessionStorage.getItem('userInfo');
      if (!userBase) {
        url += '&refresh=1';
      } else if (!userBase.member) {
        url += '&refresh=1';
      }
      sessionStorage.setItem('needRefreshPage', true);
      if (this.loginType === 'wechat') {
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function (res) {
            console.log('跳转回小程序的页面fail', res);
          },
        });
      } else {
        my.redirectTo({
          url: url,
        });
      }
    },
    closeEnd() {
      this.codeShow = false;
    },
    refreshTaskList() {
      this.queryActivityCheckinGiftDetailH5();
    },
  },
};
</script>

<style lang="scss" scoped>
.top-half {
  background-size: 100% 80%;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 0.9102;
  position: relative;
}
.sign_in {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  position: relative;
  overflow: scroll;
}
.sign_in .disabled {
  background: #f7f7f7 !important;
  color: #bbbec4 !important;
  box-shadow: 0 0 10px 4px rgba(187, 219, 235, 0.19) !important;
}
.appointment-check-in {
  position: absolute;
  left: 4%;
  top: 70vw;
  box-shadow: 0 0 12px 8px rgba(162, 162, 162, 0.07);
  width: 92%;
  border-radius: 10px;
  margin: 0 auto;
}
.appointment-check-in {
  .reward-list-len:first-child {
    margin-top: 0;
  }
  .reward-list-len:last-child {
    margin-bottom: 22.5px;
  }
}
.float-item {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
}

.activity-rule {
  border: 1px solid rgba(255, 255, 255, 1);
  border-right: transparent;
  border-radius: 50px 0 0 50px;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  padding: 4px 5px;
  margin-top: 5px;
}
.sign-in-reward-list {
  background: #ffffff;
  border-radius: 10px;
  height: 130px;
  margin-top: 10px;
  padding: 10px 15px;
  .gift-type {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 500;
  }
  .reward-info {
    display: flex;
    align-items: center;
    padding: 3vw 0;
    img {
      height: 16.133vw;
      width: 16.133vw;
    }
    .gift-info {
      margin-left: 3vw;
      width: 100%;
      .gift-item-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .text-decoration {
          text-decoration: underline;
          width: 52px;
          color: #256fff;
          font-size: 12px;
        }
      }
      .gift-item {
        display: flex;
        align-items: flex-end;
        width: 100%;
        justify-content: space-between;

        .button-item {
          height: 30px;
          border-radius: 5vw;
          padding: 0px 2vw;
          text-align: center;
          line-height: 30px;
          font-size: 12px;
          white-space: nowrap;
          overflow: hidden;
          flex-shrink: 0;
        }
        .to-finish {
          background: #256fff;
          color: #ffffff;
        }
        .to-use {
          border: 1px solid #256fff;
          color: #256fff;
        }
        .conditions-disabled {
          background: #e0e0e0;
          color: #ffffff;
        }
      }
      .gift-title {
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        font-weight: 400;
      }
      .gift-name {
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
      .gift-time {
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
  }
}
.van-dialog {
  overflow: inherit;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .explain {
    width: 345px;
    height: 332.5px;
    padding: 12px 25.5px 19.5px 25px;
    background: #ffffff;
    border-radius: 12px;
    position: relative;
    .explain_title {
      padding: 15px 0;
      font-size: 21px;
      color: #1a1a1a;
      text-align: center;
    }
    .explain_content {
      height: 240.5px;
      overflow: auto;
    }
    .explain_content /deep/ img {
      width: 100%;
    }
    .explain_closeDialog {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: white;
      font-size: 23px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 150%);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.success-dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
}
.success {
  width: 76.4%;
  height: 250px;
  display: flex;
  justify-content: center;
  position: relative;
  border-radius: 12.5px;
  background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
  align-items: center;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    top: -2vw;
  }
  .closeDialog {
    width: 30px;
    height: 30px;
    border: 1px solid white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: white;
    font-size: 22.5px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 200%);
    bottom: 15px;
  }
}
.success_content {
  width: 92%;
  left: 4%;
  position: absolute;
  top: 60px;
  padding-left: 11px;
  padding-right: 11px;
  .success_title {
    margin: 20px 0 5px 0;
    font-size: 20px;
    color: #000000;
    text-align: center;
    font-weight: 600;
  }
  .success_reward {
    font-size: 14px;
    color: #40b2f4;
    text-align: center;
    height: 35px;
    margin: 10px 0;
    line-height: 25px;
    .success_t {
      font-size: 14px;
      color: #000000;
      text-align: center;
      font-weight: 400;
    }
  }
}
.success-gift-list-parent {
  max-height: 130px;
  width: 100%;
  overflow: auto;
  border-radius: 12px;
  background-color: #fff;
  position: relative;
}
.success-gift-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 15px;
  .gift-name {
    font-size: 12px;
    color: #000000;
    width: 60%;
    letter-spacing: 0;
    font-weight: 500;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1; //最多显示1行
    overflow: hidden;
    white-space: nowrap;
  }
  .to-use-button {
    border: 1px solid rgba(37, 111, 255, 1);
    border-radius: 30px;
    font-size: 14px;
    color: #256fff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    padding: 2px 15px;
  }
}
.ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in-gift.vue